// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AuthorizationConfig, GeneralEnvironmentInfo } from '../app/services/authorization_config';
export const environment: AuthorizationConfig & GeneralEnvironmentInfo = {
  production: true,
  issuer_uri: 'https://oneid.dewa.gov.ae',
  client_id: 'MOM',    
  client_secret:'3FxID36eHwu1TbTAvUvowxt5fhZ6LO0JCRBHPxAYjfoQ6zk2GJYyzDsMXCwa2Gsx',
  redirect_uri: 'https://mom.dewa.gov.ae/callback.html',
  verifyToken:'https://oneid.dewa.gov.ae/as/introspect.oauth2',
  extras: {},
  isPingEnable:true,
  appuri:'mom.dewa.gov.ae',
  iscaptcharequired:true
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
